/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { Vector2 } from 'three';

import { isPlainObject } from '@spazious/dollhouse-utils';

/**
 * Convert the given object to a Vector2.
 */
export const toVector2 = (obj: any, optionalTarget?: Vector2): Vector2 => {
  const target = optionalTarget ?? new Vector2();
  if (Array.isArray(obj)) {
    return target.fromArray(obj);
  } else if (isPlainObject(obj)) {
    return target.set(obj.x, obj.y);
  } else if (obj instanceof Vector2) {
    return target.copy(obj);
  }

  throw new Error('toVector2: invalid input');
};
